import React from 'react';
import { Link } from 'react-router-dom'
import '../styles/header.scss'


class Header extends React.Component {
    componentDidMount() {

        const hamburger = document.querySelector(".hamburger");
        const navLinks = document.querySelector(".nav-links");
        const links = document.querySelectorAll(".nav-links li");

        hamburger.addEventListener("click", () => {
            navLinks.classList.toggle("open");
            links.forEach(link => {
                link.classList.toggle("fade");
            });
        });


        window.onscroll = function () { onScrollNavigation() };

        var navbar = document.getElementById("navigation");
        var sticky = navbar.offsetTop;

        function onScrollNavigation() {
            if (window.pageYOffset >= sticky) {
                navbar.classList.add("sticky")
            } else {
                navbar.classList.remove("sticky");
            }
        }
    }


    render() {
        return (

            <div className="header">
                <div className="top-tab">
                    <div className="top-tab-info">
                        <span className="call-number"><span className="top-tab-title">Call:</span> (843) 832-2400</span>
                        <span className="open-hours"><span className="top-tab-title">Hours:</span> Mon-Sat: 9:30am-7:00pm | Sun: 11:00am-6:00pm</span>
                    </div>
                </div>
                <nav id="navigation">
                    <div className="hamburger">
                        <div className="line"></div>
                        <div className="line"></div>
                        <div className="line"></div>
                    </div>
                    <ul className="nav-links">
                        <div className='options'>
                            <Link className='business-name' to='/'>
                                <span className="creative-text">Creative</span><span className="nails-text"> Nails</span>
                            </Link>
                            <Link className='option' to='/' >
                                Home
                            </Link>
                            <Link className='option' to='/about'>
                                About
                            </Link>
                            <Link className='option' to='/services'>
                                Services & Price
                            </Link>
                            <Link className='option' to='/gallery'>
                                Gallery
                            </Link>
                            {/* <Link className='option' to='/prices'>
                                Prices
                            </Link> */}
                            {/* <Link className='option' to='/contact'>
                                Contact
                            </Link> */}
                        </div>
                    </ul>
                </nav>
            </div>
        )
    }
}

export default Header